export default __webpack_public_path__ + "static/media/usedby-long.56a42e54.png";